import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  checkCredential,
  credentialKeys,
  listConnectors,
  listCredentials,
  removeCredential,
} from '../../entities/credential';

export const useCredentials = () => {
  const client = useQueryClient();
  const refresh = () => client.invalidateQueries({ queryKey: credentialKeys.all });

  const list = useQuery({ queryKey: credentialKeys.list, queryFn: listCredentials });
  // The catalog changes with a deploy, not while the screen is open.
  const connectors = useQuery({
    queryKey: credentialKeys.connectors,
    queryFn: listConnectors,
    staleTime: Infinity,
  });

  const check = useMutation({ mutationFn: checkCredential, onSuccess: refresh });
  const remove = useMutation({ mutationFn: removeCredential, onSuccess: refresh });

  return { list, connectors, check, remove, refresh };
};

export type TCredentials = ReturnType<typeof useCredentials>;
